module.exports = __webpack_public_path__ + "img/inco4.9d043074.png";